import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-key-offer-modal',
  templateUrl: './key-offer-modal.component.html',
  imports: [TranslateModule],
})
export class KeyOfferModalComponent implements OnChanges {
  @ViewChild('modalRef') modalRef: ElementRef;

  @Input() modalTitle = '';
  @Input() entityId: number;
  @Input() keyOfferings: { description: string }[];

  @Output() dismissModal = new EventEmitter<void>();

  constructor(private readonly modalService: NgbModal) {}

  ngOnChanges(): void {
    if (this.entityId) {
      this.openModal();
    }
  }

  private openModal(): void {
    this.modalService
      .open(this.modalRef, {
        centered: true,
        backdrop: 'static',
        scrollable: true,
        windowClass: 'key-offer__modal people__modal',
      })
      .result.then(
        () => {
          this.entityId = null;
          this.keyOfferings = [];
        },
        () => {
          this.entityId = null;
          this.keyOfferings = [];

          this.dismissModal.emit();
        }
      );
  }
}
